import { Box, Chip, CircularProgress, Tooltip, Typography, } from "@mui/material";
import { IRole } from "../../../interfaces/common/roles";
import { Permission } from "../../../interfaces/common/permissions";
import useRoles from "../../../hooks/roles";
import { EmployeeType } from "../../delivery-company-components/employees/create-employee-form/create-employee-form.interfaces";
import { user_is_admin } from "../../../utils/permissions";
import { AdminPanelSettings } from "@mui/icons-material";


const RoleChip = ({role, roles}: {role: IRole, roles: IRole[]}) => {
    
  const buildRoleTooltip = (roleId: number) => {
    const role = roles.find((r) => r.id === roleId);
    if (!role) return null;

    const globalPerms = role.permissions.filter((p: Permission) => p.is_global);
    const grouped: Record<string, string[]> = {};

    role.permissions
      .filter((p: Permission) => !p.is_global)
      .forEach((p: Permission) => {
        const action = p.action.split('_')[0]; // take "add" from "add_customer"
        if (!grouped[p.model_label]) grouped[p.model_label] = [];
        if (!grouped[p.model_label].includes(action)) {
          grouped[p.model_label].push(action);
        }
      });

    return (
      <Box sx={{ p: 1, maxWidth: 300 }}>
        <Typography variant="h5" sx={{ color: 'white', fontWeight: 'bold', mb: 1 }}>
          {role.name} Group
        </Typography>
        {role.description && (
          <Typography variant="body2" sx={{ color: 'white', mb: 1 }}>
            {role.description}
          </Typography>
        )}

        <br />
        {globalPerms.length > 0 && (
          <Box sx={{ mb: 1 }}>
            <Typography variant="body2" sx={{ color: 'white' }}>
              🌐 <b>Global Permissions</b>: {globalPerms.map((p) => p.name.replace('Can ', '').toLowerCase()).join(', ')}
            </Typography>
          </Box>
        )}

        {Object.entries(grouped).map(([modelLabel, actions]) => (
          <Typography key={modelLabel} variant="body2" sx={{ color: 'white', mb: 2 }}>
            <b>{modelLabel}:</b> {actions.join(', ')}
          </Typography>
        ))}
      </Box>
    );
  };


   return <Tooltip
                key={role.id}
                title={buildRoleTooltip(role.id)}
                arrow
                PopperProps={{
                sx: {
                    '& .MuiTooltip-tooltip': {
                    backgroundColor: '#333', // dark background
                    color: 'white',
                    },
                },
                }}
            >
                <Chip
                label={role.name}
                sx={{
                    backgroundColor: '#1976d2',
                    color: 'white',
                    cursor: 'pointer'
                }}
                size={"small"}
                />
            </Tooltip>
}

export const RoleChips = ({is_admin, roles, allRoles, allRolesLoading, centered = true}: {is_admin: boolean, roles: IRole[], allRoles: IRole[], allRolesLoading: boolean, centered?: boolean}) => {
  if (is_admin) return <Chip size='small' color="primary" icon={<AdminPanelSettings />} label={"Admin"} /> 
  return allRolesLoading ? <CircularProgress size={20} /> : <Box display={"flex"} gap={1} flexWrap={"wrap"} justifyContent={centered ? "center" : undefined}>
      {roles.map(role => <RoleChip key={role.id} role={role} roles={allRoles} />)}
    </Box> 
}
